<router-outlet [dir]="dir"></router-outlet>
